module.exports = __webpack_public_path__ + "static/media/5.eb78f8b9.PNG";